export default {
  reconAnalytics({ commit }, filters) {
    commit('toggleLoading', true);

    return new Promise((resolve) => {
      setTimeout(() => resolve(filters), 2000);
    })
      .then(() => {
        commit('setForm', filters);
        commit('toggleLoading', false);
      })
      .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-filters/store/actions.js